import { SociosSocketEvent, type SocketsListener, useSocketEventListener, withRefreshStrategy } from '@capsicum/common';
import { FeedTypes } from '@capsicum/socios-core';
import { useMemo } from 'react';

import { useRemoveActivityFromFeed } from '../hooks';

const FeedsListenersOn = () => {
	const { removeActivity } = useRemoveActivityFromFeed([
		FeedTypes.FAVOURITE_TEAM,
		FeedTypes.FOLLOWED_TEAMS,
		FeedTypes.SOCIAL_FEED,
		FeedTypes.PARTNER_FEED,
		FeedTypes.SUGGESTED_FEED
	]);

	const listeners = useMemo(
		() =>
			new Map<SociosSocketEvent, SocketsListener>([
				[
					SociosSocketEvent.SOCIAL_ACTIVITY_REMOVED,
					withRefreshStrategy({
						listener: data => removeActivity(data.payload.activityId)
					})
				]
			]),
		[removeActivity]
	);

	useSocketEventListener(listeners);

	return null;
};

export const FeedsListeners = () => {
	return <FeedsListenersOn />;
};
